import type { PaymentMethodCard } from '@patrianna/shared-patrianna-types/store/PaymentsFlowModule'
import { getCardTypeIcon } from '@patrianna/shared-utils/helpers'

export const maskifyCreditCard = (creditCard: string) => {
  if (creditCard.length < 6) {
    return `**** **** **** ${creditCard}`
  } else {
    const last4Characters = creditCard.substr(-4)
    const maskingCharacters = creditCard.substr(0, creditCard.length - 5).replace(/\d/g, '*')

    return `${maskingCharacters}${last4Characters}`
  }
}

export const generateCardLogo = (cardType: PaymentMethodCard['cardType'] | string) => {
  if (cardType === null) {
    return null
  }

  if (cardType?.includes('/')) {
    return cardType
  }

  return `${process.env.IMG_ORIGIN}/logos/${getCardTypeIcon(cardType?.toLowerCase())}.svg`
}
